export const contactsTabValueTypes = {
  information: 'information',
  sharedInformation: 'sharedInformation',
};
